import { FC, SVGProps } from 'react';

export const UserIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.25003 11C9.25003 7.27208 12.2721 4.25 16 4.25C19.7279 4.25 22.75 7.27208 22.75 11C22.75 13.4884 21.4035 15.6623 19.3993 16.8328C23.3976 17.8975 26.858 20.99 27.7392 26.1231C27.8093 26.5313 27.5352 26.9191 27.1269 26.9892C26.7187 27.0593 26.3309 26.7851 26.2608 26.3769C25.2889 20.7153 20.7728 17.9045 16.1521 17.9134C11.5262 17.9223 6.89676 20.76 5.7346 26.4013C5.65103 26.807 5.25439 27.0682 4.8487 26.9846C4.443 26.901 4.18188 26.5044 4.26545 26.0987C5.29801 21.0865 8.75718 18.0133 12.7075 16.8939C10.6445 15.739 9.25003 13.5324 9.25003 11ZM16 5.75C13.1005 5.75 10.75 8.10051 10.75 11C10.75 13.8995 13.1005 16.25 16 16.25C18.8995 16.25 21.25 13.8995 21.25 11C21.25 8.10051 18.8995 5.75 16 5.75Z"
			fill="currentColor"
		/>
	</svg>
);
